const socialShare = document.querySelector('[data-social-share]')
const socialLinks = document.querySelector('[data-social-links]')

const handleToggle = () => socialLinks.classList.toggle('--is-open')

if (socialShare) {
    socialShare.onclick = () => handleToggle()
}
